<section class="home">
    <div class="container">
        <div class="home__inner">
            <h1 class="home__title title" [innerHTML]="'index.home.title' | translate"></h1>
            <p class="home__subtitle">{{ 'index.home.subtitle' | translate }}</p>
            <button class="button-big">{{ 'index.home.button' | translate }}</button>
        </div>
    </div>
</section>
<section class="info">
    <div class="container mob">
        <div class="info__money">
            <ul class="tabs">
                <li class="tabs__item" (click)="staticFilter = '24h'">{{ 'index.info.tabs.24h' | translate }}</li>
                <li class="tabs__item" (click)="staticFilter = '7d'">{{ 'index.info.tabs.7d' | translate }}</li>
                <li class="tabs__item" (click)="staticFilter = '30d'">{{ 'index.info.tabs.30d' | translate }}</li>
                <div class="tabs__background"></div>
            </ul>
            <div class="tabs__inner">
                <div class="info__transaction tabs__content">
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item1.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.total_listed' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics[staticFilter].totalListed : ''}}</p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item2.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.transaction_volume' | translate
                            }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics[staticFilter].transactionVolumePol : ''}}
                        </p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item3.png" alt="diamond">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.items_traded' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics[staticFilter].itemsTraded : ''}}</p>
                    </div>
                </div>
                <!-- <div class="info__transaction tabs__content">
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item1.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.total_listed' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["7d"].totalListed : ''}}</p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item2.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.transaction_volume' | translate
                            }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["7d"].transactionVolumePol : ''}}</p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item3.png" alt="diamond">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.items_traded' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["7d"].itemsTraded : ''}}</p>
                    </div>
                </div>
                <div class="info__transaction tabs__content">
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item1.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.total_listed' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["30d"].totalListed : ''}}</p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item2.png" alt="gold">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.transaction_volume' | translate
                            }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["30d"].transactionVolumePol : ''}}
                        </p>
                    </div>
                    <div class="info__transaction-item">
                        <img src="/assets/image/info/transaction-item3.png" alt="diamond">
                        <h3 class="info__transaction-title">{{ 'index.info.transaction.items_traded' | translate }}</h3>
                        <p class="info__transaction-num">{{statistics ? statistics["30d"].itemsTraded : ''}}</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    <info-sales></info-sales>
</section>
<section class="list">
    <div class="container mob">
        <div class="list__header">
            <h2 class="title">{{ 'index.recent_listed.title' | translate }}</h2>
            <a [routerLink]="['/', lang, 'marketplace']" class="list__more">{{ 'index.recent_listed.view_all' |
                translate }}<span>
                    <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.41905 11.1115C-0.0841403 10.6802 -0.142414 9.92261 0.288892 9.41942L3.21951 6.00037L0.288892 2.58132C-0.142414 2.07813 -0.0841403 1.32057 0.41905 0.88926C0.922241 0.457954 1.6798 0.516229 2.11111 1.01942L5.71111 5.21942C6.0963 5.66881 6.0963 6.33193 5.71111 6.78132L2.11111 10.9813C1.6798 11.4845 0.922241 11.5428 0.41905 11.1115Z"
                            fill="white" />
                    </svg>
                </span></a>
        </div>
        <div class="list__inner">
            <div class="list__item" *ngFor="let item of recentListed; let i = index">
                <div class="list__card">
                    <a [routerLink]="['/', lang, 'marketplace','view', item.id]">
                        <div class="list__card-rarity rarity"
                            [ngClass]="{'common': item.rarity == rarityType.Common, 'rare': item.rarity == rarityType.Rare, 'legendary': item.rarity == rarityType.Legendary}">
                            {{item.rarity | rarityName | translate}}</div>
                        <img class="list__card-img" [src]="item.imageUrl" [alt]="item.name" />
                        <div class="list__card-info">
                            <div class="list__card-left">
                                <div class="list__card-name">{{item.type | creatureType | translate}}</div>
                                <div class="list__card-id">{{item.nftTokenId}}</div>
                                <div class="list__card-time">{{item.tradeListing!.createdAt | timeAgo}}</div>
                            </div>
                            <div class="list__card-right">
                                <div class="list__card-score">#{{item.nftBatchIndex}}/{{item.nftBatchSize}}</div>
                                <div class="list__card-pol">{{item.tradeListing!.price}} <span>ETH</span></div>
                                <div class="list__card-price">{{item.tradeListing!.price | ethPrice}} USD</div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="list__swiper swiper">
            <div class="swiper-wrapper">
                <a [routerLink]="['/', lang, 'marketplace','view', item.id]" class="list__card swiper-slide" *ngFor="let item of recentListed; let i = index">
                    <div class="list__card-rarity rarity" [ngClass]="{'common': item.rarity == rarityType.Common, 'rare': item.rarity == rarityType.Rare, 'legendary': item.rarity == rarityType.Legendary}">{{item.rarity | rarityName | translate}}</div>
                    <img class="list__card-img" [src]="item.imageUrl" [alt]="item.name" />
                    <div class="list__card-info">
                        <div class="list__card-left">
                            <div class="list__card-name">{{item.type | creatureType | translate}}</div>
                            <div class="list__card-id">{{item.nftTokenId}}</div>
                            <div class="list__card-time">{{item.tradeListing!.createdAt | timeAgo}}</div>
                        </div>
                        <div class="list__card-right">
                            <div class="list__card-score">#{{item.nftBatchIndex}}/{{item.nftBatchSize}}</div>
                            <div class="list__card-pol">{{item.tradeListing!.price}} <span>ETH</span></div>
                            <div class="list__card-price">{{item.tradeListing!.price | ethPrice}} USD</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>
<section class="blog">
    <div class="container mob">
        <h2 class="blog__title title">{{ 'index.blog.title' | translate }}</h2>
        <blog-swiper-component></blog-swiper-component>
    </div>
</section>
<section class="list">
    <div class="container mob">
        <div class="list__header">
            <h2 class="title">{{ 'index.discover.title' | translate }}</h2>
            <a [routerLink]="['/', lang, 'marketplace']" class="list__more">{{ 'index.discover.view_all' | translate
                }}<span>
                    <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.41905 11.1115C-0.0841403 10.6802 -0.142414 9.92261 0.288892 9.41942L3.21951 6.00037L0.288892 2.58132C-0.142414 2.07813 -0.0841403 1.32057 0.41905 0.88926C0.922241 0.457954 1.6798 0.516229 2.11111 1.01942L5.71111 5.21942C6.0963 5.66881 6.0963 6.33193 5.71111 6.78132L2.11111 10.9813C1.6798 11.4845 0.922241 11.5428 0.41905 11.1115Z"
                            fill="white" />
                    </svg>
                </span></a>
        </div>
        <div class="list__inner">
            <div class="list__item" *ngFor="let item of discoverCreatures; let i = index">
                <div class="list__card">
                    <a [routerLink]="['/', lang, 'marketplace','view', item.id]">
                        <div class="list__card-rarity rarity"
                            [ngClass]="{'common': item.rarity == rarityType.Common, 'rare': item.rarity == rarityType.Rare, 'legendary': item.rarity == rarityType.Legendary}">
                            {{item.rarity | rarityName | translate}}</div>
                        <img class="list__card-img" [src]="item.imageUrl" [alt]="item.name" />
                        <div class="list__card-info">
                            <div class="list__card-left">
                                <div class="list__card-name">{{item.type | creatureType | translate}}</div>
                                <div class="list__card-id">{{item.nftTokenId}}</div>
                                <div class="list__card-time">{{item.tradeListing!.createdAt | timeAgo}}</div>
                            </div>
                            <div class="list__card-right">
                                <div class="list__card-score">#{{item.nftBatchIndex}}/{{item.nftBatchSize}}</div>
                                <div class="list__card-pol">{{item.tradeListing!.price}} <span>ETH</span></div>
                                <div class="list__card-price">{{item.tradeListing!.price | ethPrice}} USD</div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="list__swiper swiper">
            <div class="swiper-wrapper">
                <a *ngFor="let item of discoverCreatures; let i = index" [routerLink]="['/', lang, 'marketplace','view', item.id]" class="list__card swiper-slide">
                    <div class="list__card-rarity rarity" [ngClass]="{'common': item.rarity == rarityType.Common, 'rare': item.rarity == rarityType.Rare, 'legendary': item.rarity == rarityType.Legendary}">{{item.rarity | rarityName | translate}}</div>
                    <img class="list__card-img" [src]="item.imageUrl" [alt]="item.name" />
                    <div class="list__card-info">
                        <div class="list__card-left">
                            <div class="list__card-name">{{item.type | creatureType | translate}}</div>
                            <div class="list__card-id">{{item.nftTokenId}}</div>
                            <div class="list__card-time">{{item.tradeListing!.createdAt | timeAgo}}</div>
                        </div>
                        <div class="list__card-right">
                            <div class="list__card-score">#{{item.nftBatchIndex}}/{{item.nftBatchSize}}</div>
                            <div class="list__card-pol">{{item.tradeListing!.price}} <span>ETH</span></div>
                            <div class="list__card-price">{{item.tradeListing!.price | ethPrice}} USD</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>